import Cookies from 'js-cookie'
const TokenKey = 'X-Token'
const LoginNameKey = "LOGININFO-COOKIE"
export function getToken() {
  return window.localStorage.getItem('X-Token')
  // return window.localStorage.getItem('TokenKey')
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey,token)
  // return  window.localStorage.setItem(TokenKey,token)
}

export function removeToken() {
  window.localStorage.removeItem(TokenKey)
  return Cookies.remove(TokenKey)
  // return window.localStorage.removeItem(TokenKey)
}
//记住密码
export function rememberAccount(data){
  return Cookies.set(LoginNameKey, data)
}
//忘记密码
export function forgetAccount(){
  return Cookies.remove(LoginNameKey)
}

//获取登录账号信息
export function getAccount(){
  return Cookies.get(LoginNameKey)
}